import { useAppSelector } from 'store/hooks';
import { selectFeatureFlag } from 'features/feature-set/featuresSlice';
import { FeatureFlagType } from 'features/feature-set/types';

export const useFeatureFlag = (featureFlag: FeatureFlagType) =>
  useAppSelector((state) => selectFeatureFlag(state, featureFlag));
